/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, OnInit } from '@angular/core';
import { SearchResultsContentComponent } from '../search-results-content.component';
import { SearchService } from '../../services/search.service';
import { LoggerService } from '../../../shared/services/logger.service';
import { QueryService } from '../../../map/services/query.service';
import { Store } from '@ngxs/store';

@Component({
    selector: 'dash-gis-search-results-print',
    templateUrl: './search-results-print.component.html',
    styleUrls: [ './search-results-print.component.scss' ],
})
export class SearchResultsPrintComponent extends SearchResultsContentComponent implements OnInit {
    constructor(searchService: SearchService, queryService: QueryService, loggerService: LoggerService, store: Store) {
        super(searchService, queryService, loggerService, store);

        this.forPrint = true;
    }
}
